module.exports = __webpack_public_path__ + "24015d7e6b793239601a1caa8d2ecf7c.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/gcapp.jpg
// module id = 487
// module chunks = 0